import { Fragment } from "react";
import { CompaniesTableHeader } from "./CompaniesTableHeader";
import companiesStyles from "../styles/companies.module.scss";
import { CompaniesTableBody } from "./CompaniesTableBody";
import { ICompany } from "../../../api/companies/types";

interface CompaniesTableProps {
  companies: ICompany[];
  onEditCompany: (company: ICompany) => void;
}

const CompaniesTable = ({ companies, onEditCompany }: CompaniesTableProps) => {
  const sortedCompanies = companies?.slice().sort((a, b) => b.id - a.id);

  return (
    <div className={companiesStyles["companiesTable"]}>
      <div className={companiesStyles["companiesTable_bodyContent"]}>
        <CompaniesTableHeader />
        <div>
          {sortedCompanies?.map(company => (
            <Fragment key={company.id}>
              <CompaniesTableBody
                company={company}
                onEdit={onEditCompany}
              />
            </Fragment>
          ))}
        </div>
      </div>
    </div>
  )
}

export default CompaniesTable;
